document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("introVideo");
  const section = document.querySelector(".video-intro");
  const featuredImage = document.querySelector(".landing_featured_image");

  /** --- CLICKING THE IMAGE SKIPS THE INTRO IMMEDIATELY --- **/
  if (featuredImage) {
    featuredImage.addEventListener("click", function () {
      localStorage.setItem("hasSeenIntro", "true"); // mark as seen
      if (section) section.remove(); // remove intro screen
      document.body.style.overflow = ""; // restore scrolling
    });
  }

  /** --- IF USER HAS ALREADY SEEN THE INTRO --- **/
  if (localStorage.getItem("hasSeenIntro")) {
    if (section) section.remove();
    return; // stop here, don't play video
  }

  /** --- PLAY INTRO VIDEO IF NOT SEEN YET --- **/
  if (video && section) {
    section.classList.add("show-intro");
    document.body.style.overflow = "hidden";

    video.addEventListener("ended", function () {
      // Mark as seen immediately
      localStorage.setItem("hasSeenIntro", "true");

      // Fade out
      section.style.opacity = "0";

      setTimeout(() => {
        section.remove();
        document.body.style.overflow = "";
      }, 600);
    });
  }
});
